module.exports = __webpack_public_path__ + "img/lg_ring_g_s_0_1.7805d5ae.png";